import { Injectable } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";
import { AlertController } from "@ionic/angular";
import { TranslocoService } from "@ngneat/transloco";
import { interval } from "rxjs";
import { filter } from "rxjs/operators";
import { RideOpsUiService } from "./rideops-ui.service";

@Injectable({
	providedIn: "root",
})
export class UpdateService {
	static updateAlertId = "update-alert";

	constructor(
		private updates: SwUpdate,
		private alertController: AlertController,
		private translocoService: TranslocoService,
		private rideOpsUi: RideOpsUiService,
	) {}

	private activated: boolean;
	public activate = () => {
		if (this.activated) {
			return;
		}

		this.activated = true;

		this.updates.versionUpdates
			.pipe(filter((event) => event.type === "VERSION_READY"))
			.subscribe(this.blockForUpdate);

		// Only check for updates, if servieworker is available
		if (this.updates.isEnabled) {
			const everyMinute$ = interval(60000);
			everyMinute$.subscribe(this.checkForUpdate);
		}

		this.updates.unrecoverable.subscribe((_event) => {
			//The app is in an unrecoverable state, because the user has an old version of the app
			//where some of the .js files have been removed from the cache, and cant be loaded
			this.showUnrecoverableError();
		});
	};

	public checkForUpdate = async (): Promise<boolean> => {
		try {
			return await this.updates.checkForUpdate();
		} catch (error) {
			console.error(error);
			// checkForUpdate will fail if running in dev or incognito, without the serviceworker installed
			return false;
		}
	};

	private showUnrecoverableError = async () => {
		const alert = await this.alertController.create({
			header: this.translocoService.translate("UNRECOVERABLE_ERROR_DETECTED__TITLE"),
			message: this.translocoService.translate("UNRECOVERABLE_ERROR_DETECTED__MESSAGE"),
			buttons: [this.translocoService.translate("UNRECOVERABLE_ERROR_DETECTED__OK")],
			backdropDismiss: false,
			cssClass: this.rideOpsUi.isV2Active() ? "operators-v2-dialog" : undefined,
		});

		await alert.present();
		await alert.onDidDismiss();

		document.location.reload();
	};

	private blockForUpdate = async () => {
		const alert = await this.alertController.create({
			header: this.translocoService.translate("UPDATE_MODAL__TITLE"),
			message: this.translocoService.translate("UPDATE_MODAL__MESSAGE"),
			buttons: [this.translocoService.translate("UPDATE_MODAL__OK")],
			backdropDismiss: false,
			id: UpdateService.updateAlertId,
			cssClass: this.rideOpsUi.isV2Active() ? "operators-v2-dialog" : undefined,
		});

		await alert.present();
		await alert.onDidDismiss();

		document.location.reload();
	};
}
